import {
  // addHoursToDate,
  // AgendaDaysToShow,
  // AgendaView,
  type CalendarEvent,
  type CalendarView,
  // WeekView
} from "~/features/dashboard/pages/calendar/components"
import { EventCalendar } from "../../../components"
import type { RefillEvent } from "../../../components/types"
// import { WeekAppointment } from "./week-appointment"
// import { ModWeekView } from "./week-view-mod"


export interface EventCalendarProps {
  events?: CalendarEvent[]
  timeRange?: string  
  onEventAdd?: (event: CalendarEvent) => void
  onEventUpdate?: (event: CalendarEvent) => void
  onEventDelete?: (eventId: string) => void
  className?: string
  view: CalendarView
  setView: (view: CalendarView) => void
}

// const statuses = [
//   { label: "Ongoing", color: "bg-green-600" },
//   { label: "Completed", color: "bg-green-100" },
//   { label: "Upcoming", color: "border border-green-600" },
//   { label: "Cancelled", color: "bg-gray-300" },
// ];


interface MedicationRefillsProps {
  events: CalendarEvent[]
  view: CalendarView
  setView: (view: CalendarView) => void
  onEventAdd: (event: CalendarEvent) => void
  onEventUpdate: (event: CalendarEvent) => void
  onEventDelete: (eventId: string) => void
}

export function MedicationRefills({ 
  events,
  view,
  setView,
  onEventAdd,
  onEventUpdate,
  onEventDelete
}: MedicationRefillsProps) {
  // Filter events to only show refills
  const refillEvents = events.filter(event => event.type === 'refill')

  const handleEventAdd = (event: CalendarEvent) => {
    const refillEvent: RefillEvent = {
      ...event,
      type: 'refill',
      prescriptionId: "",
      clientName: "",
      title: event.title ?? "",
      medication: "",
      quantity: 0,
      request_datetime: "",
      status: "pending"
    }
    onEventAdd(refillEvent)
  }

  return (
    <EventCalendar
      events={refillEvents}
      view={view}
      setView={setView}
      onEventAdd={handleEventAdd}
      onEventUpdate={onEventUpdate}
      onEventDelete={onEventDelete}
    />
  )
}